const menuitems = [
  { label: 'My RSVPs', to: '/rsvp' },
  { label: 'Case Management', to: '/case-management' },
  { label: 'Parking', to: '/requests' },
  { label: 'Account', to: '/account' },
  { label: 'Logout', to: '/logout' },
];

export default menuitems;